import { render } from "./DiseaseIcon.vue?vue&type=template&id=4d475492"
import script from "./DiseaseIcon.vue?vue&type=script&lang=js"
export * from "./DiseaseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__